<mat-card>
  <app-card-header
    icono="admin_panel_settings"
    [title]="title"
    [subtitle]="subtitle"
    [draggable]="false"
  ></app-card-header>

  <mat-divider></mat-divider>

  @if (form && !loading) {
    <form
      id="form"
      [formGroup]="form"
      autocomplete="off"
      (ngSubmit)="onSubmit()"
    >
      <!-- Content -->
      <mat-card-content
        [class.cardContentFullscreen]="!subtitle"
        [class.cardContentFullscreenSubtitle]="subtitle"
        class="card-content-crear"
      >
        <!-- Nombre -->
        <app-content-card title="Información del rol" icon="badge" color="blue">
          <section class="inputs-group">
            <mat-form-field style="width: 100%">
              <mat-label>Nombre</mat-label>
              <input matInput formControlName="nombre" />
              <mat-icon matPrefix>badge</mat-icon>
            </mat-form-field>

            @if (esClienteNivel0) {
              <mat-slide-toggle formControlName="global" color="primary">
                <span class="toggle-label">
                  <mat-icon>public</mat-icon>
                  <span>Rol Global</span>
                </span>
              </mat-slide-toggle>
              <p class="hint-text-small">
                Los roles globales están disponibles para todos los clientes del
                sistema.
              </p>
            }
          </section>
        </app-content-card>

        <!-- Acciones / Permisos -->
        <app-content-card
          title="Permisos y Acciones"
          icon="security"
          color="blue"
        >
          <section class="acciones-container">
            <p class="hint-text">
              Seleccioná las acciones que los usuarios con este rol podrán
              realizar. Las acciones están agrupadas por módulo para facilitar
              la selección.
            </p>

            @if (accionesPorModulo.length > 0) {
              <mat-accordion class="acciones-accordion" multi>
                @for (grupo of accionesPorModulo; track grupo.modulo) {
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <mat-checkbox
                          [checked]="isModuloCompleto(grupo)"
                          [indeterminate]="isModuloParcial(grupo)"
                          (change)="toggleModulo(grupo, $event)"
                          (click)="$event.stopPropagation()"
                          class="modulo-checkbox"
                        >
                          <strong>{{ grupo.modulo }}</strong>
                        </mat-checkbox>
                      </mat-panel-title>
                      <mat-panel-description>
                        {{ getCantidadSeleccionadas(grupo) }} /
                        {{ grupo.acciones.length }} seleccionadas
                      </mat-panel-description>
                    </mat-expansion-panel-header>

                    <div class="acciones-list">
                      @for (accion of grupo.acciones; track accion) {
                        <mat-checkbox
                          [checked]="isAccionSeleccionada(accion)"
                          (change)="toggleAccion(accion)"
                          class="accion-checkbox"
                        >
                          {{ accion.split(' - ')[1] }}
                        </mat-checkbox>
                      }
                    </div>
                  </mat-expansion-panel>
                }
              </mat-accordion>
            } @else {
              <p>No hay acciones disponibles</p>
            }
          </section>
        </app-content-card>

        <!-- Funciones del Rol -->
        <app-content-card
          title="Funciones Especiales"
          icon="engineering"
          color="blue"
        >
          <section class="funciones-container">
            <p class="hint-text">
              Seleccioná las funciones especiales que tendrá este rol. Estas
              funciones habilitan características específicas del sistema.
            </p>

            <div class="funciones-list">
              @for (
                funcionItem of TODAS_LAS_FUNCIONES;
                track funcionItem.funcion
              ) {
                <div class="funcion-item">
                  <mat-slide-toggle
                    [checked]="isFuncionSeleccionada(funcionItem.funcion)"
                    (change)="toggleFuncion(funcionItem.funcion)"
                    color="primary"
                    class="funcion-toggle"
                  >
                    <div class="funcion-content">
                      <span class="funcion-title">
                        {{ funcionItem.funcion }}
                      </span>
                      <p class="funcion-description">
                        {{ funcionItem.descripcion }}
                      </p>
                    </div>
                  </mat-slide-toggle>
                </div>
              }
            </div>
          </section>
        </app-content-card>
      </mat-card-content>

      <mat-divider></mat-divider>

      <!-- Botones -->
      <mat-card-actions class="actions-create">
        <app-button
          matType="mat-fab extended"
          color="neutral"
          (click)="volver()"
          text="Cancelar"
          icon="close"
        ></app-button>
        <app-button
          matType="mat-fab extended"
          [disabled]="!this.form.valid || loading"
          color="primary"
          text="Guardar"
          icon="save"
          type="submit"
        ></app-button>
      </mat-card-actions>
    </form>
  } @else {
    <section class="inputs-group">
      <app-loading text="Cargando formulario..." [diameter]="60"></app-loading>
    </section>
  }
</mat-card>
